<template>
  <div
    class="bg-grey-100 w-full relative overflow-y-auto"
    style="min-height: calc(100% - 4rem)"
  >
    <div class="flex flex-wrap px-0">
      <aside class="w-full md:w-1/4">
        <slot name="sidebar"></slot>
      </aside>
      <main class="w-full md:w-3/4">
        <templates-list
          :url="url"
          :showOnlyGlobal="showOnlyGlobal"
          :search="search"
          :filters="filters"
          :templatesHeight="templatesHeight"
          :gridView="gridView"
          @selectedTemplate="selectedTemplate"
          @editTemplate="editTemplate"
          @renameTemplate="renameTemplate"
          @cloneTemplate="cloneTemplate"
          @deleteTemplate="deleteTemplate"
        >
        </templates-list>
      </main>
    </div>
  </div>
</template>

<script>
import TemplatesList from './TemplatesList';
export default {
  name: 'TemplateSelectionGrid',
  components: {
    TemplatesList,
  },

  props: {
    url: {
      required: false,
    },
    filters: {
      required: false,
    },
    search: {
      required: false,
    },
    showOnlyGlobal: {
      required: false,
    },
    templatesHeight: {
      required: false,
      default: 'calc(100vh - 120px)',
    },
    gridView: {
      required: false,
      default: true,
    },
  },

  methods: {
    selectedTemplate(templateId) {
      this.$emit('selectedTemplate', templateId);
    },

    editTemplate(templateId) {
      this.$emit('editTemplate', templateId);
    },

    renameTemplate(templateId){
      this.$emit('renameTemplate', templateId);
    },
    
    cloneTemplate(template) {
      this.$emit('cloneTemplate', template);
    },
    
    deleteTemplate(templateId) {
      this.$emit('deleteTemplate', templateId);
    },
  },
};
</script>
